export const CONSULTANT_PHONE = '88003330343';
